const Header2 = () => {
    return (
        <header className="relative w-full h-[20vh] md:h-[33vh] flex items-center justify-center bg-cover bg-center"
                style={{ backgroundImage: 'url(https://imgur.com/rOvKIMD.png)' }}>
            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            {/* Content */}
            <div className="relative text-center text-white">
                <p className="text-lg md:text-xl font-thin mb-2">WELCOME TO</p>
                <h1 className="text-3xl md:text-5xl font-bold">My Portfolio</h1>
            </div>
        </header>
    );
};

export default Header2;
